import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Switch } from "react-router";
import { Route } from "react-router-dom";

import { hasActiveFilters } from "reducers/common/ColumnFilters";
import { loadLibrary, resetForm } from "reducers/LibraryProperties";
import {
	resetSocialInfo,
	loadDSPConnections,
	loadDSPMetadata,
	loadCTAs,
	loadGoogleLocales
} from "reducers/Social";
import { AdvertiserDetails } from "reducers/AdvertiserDetails";
import { Labels } from "reducers/Labels";

import { FACEBOOK_DSP_INTERNAL_NAME } from "utils/constants";
import { GOOGLE_DSP_INTERNAL_NAME } from "widgets/social2/constants";

import CreativeGrid from "./creatives/CreativeGrid";
import ApprovalHistoryModal from "widgets/modals/creatives/ApprovalHistory";
import ImportSocialCreativesModal from "widgets/modals/creatives/bulk/ImportSocialCreativesModal";
import CreativesInfoHeader from "widgets/toolbars/CreativesInfoHeader";
import { buildSelectedCreativesList } from 'selectors/Creatives';
import AssetList from "./AssetList";
import PreviewGrid from "./previews/PreviewGrid";

import "./CreativesList.css";
// import LibraryProperties from "../store/reducers/LibraryProperties";

export default function CreativesList({ libraryId }) {
	const dispatch = useDispatch()
		, { creatives
			, dspConnections
			, libraryProperties
			,
		} = useSelector((state) => {
			return {
				creatives: buildSelectedCreativesList(state),
				dspConnections:state.social.items,
				libraryProperties: state.libraryProperties,
			};
		})
		, advertiserId = libraryProperties?.advertiser?.id;

	let hasFiltersAppliedClass = hasActiveFilters(creatives) ? "has-filters-applied" : "";

	useEffect(() => {
		dispatch(resetSocialInfo());
		dispatch(loadLibrary(libraryId));
		dispatch(loadDSPConnections(libraryId));
	}, [libraryId]);

	useEffect(() => {
		// Only load the CTA list if there are DSP connections
		if(dspConnections.length){
			dispatch(loadCTAs());
		}
		try {
			dspConnections.forEach((val) => {
				let { id, internalName } = val?.dsp || {};
				if(internalName === FACEBOOK_DSP_INTERNAL_NAME){
					dispatch(loadDSPMetadata(id));
				}
				if(internalName === GOOGLE_DSP_INTERNAL_NAME){
					dispatch(loadGoogleLocales());
				}
			});
		} catch(err){}
	}, [dspConnections]);

	useEffect(() => {
		// advertiser id is initially not in the libraryProperties obj on load
		if(advertiserId) {
			dispatch(AdvertiserDetails.loadAdvertiserDetails(libraryId));
			dispatch(Labels.loadAdvertiserTaxonomy(advertiserId));
		}
	}, [advertiserId, libraryId]);

	useEffect(() => {
		return () => {
			dispatch(resetForm());
			dispatch(AdvertiserDetails.resetDetails());
			dispatch(Labels.clearLabels());
		};
	}, []);

	return (
		<div className={`creatives-list ${hasFiltersAppliedClass}`}>
			<CreativesInfoHeader type="library" libraryId={libraryId} />
			<Switch>
				<Route
					path   = {`/library/:libraryId/assets/`}
					// We need `routeRenderProps` to get the `match.url` as a return target for closing AssetList's modals.
					render = {routeRenderProps => <AssetList libraryId={libraryId} {...routeRenderProps} />}
				/>
				<Route path="/library/:libraryId/previews/" exact render={routeRenderProps => <PreviewGrid {...routeRenderProps} libraryId={libraryId} />} />
				<Route path="/library/:libraryId/" render={routeRenderProps => <CreativeGrid {...routeRenderProps} libraryId={libraryId} />} />
			</Switch>
			<ApprovalHistoryModal />
			<ImportSocialCreativesModal />
		</div>
	);
}

CreativesList.displayName = "CreativesList";
